import css from "./Settings.module.css";
import userImg from "../../../Assets/Images/userImage2.png";
import ImgThumb from "../../../Components/ImgThumb/ImgThumb";
import Button from "../../../Components/Button/Button";
import Form from "../../../Components/Form/Form";
import AccOptions, { SecureOptions } from "./Options";
import User from "../../../Services/User";
import { toast } from "react-toastify";
import Server from "../../../Services/Server";
import { useRef } from "react";
import Url from "../../../Services/Url";
import { Post } from "../../../Services/Server";

const Settings = () => {
	const profileFormRef = useRef(null);
	const passwordFormRef = useRef(null);

	const handleSubmit = (formStructure, endpoint) => {
		const formRef =
			endpoint === "update-profile" ? profileFormRef : passwordFormRef;

		const form = formRef.current?.querySelector("form");
		if (!form) {
			toast.error("Form element not found.");
			return;
		}

		const id = User.getBiodata()?.id;
		if (!id) {
			toast.error("User ID is missing. Please log in again.");
			return;
		}

		const formData = new FormData(form);
		const dt = {};
		formData.forEach((value, key) => {
			dt[key] = value;
		});

		const updatedData = { ...dt, id };

		if (endpoint === "update-profile") {
			Post(Url.updateProfile, updatedData)
				.then((resp) => {
					toast("profile updated");
					User.setBiodata(resp);
					setTimeout(() => {
						window.location.reload();
					}, 1500);
				})
				.catch((err) => {
					const message =
						err?.response?.data?.["Null Pointer"] ||
						err?.response?.data?.message ||
						"Update failed.";

					toast.error(message, {
						theme: "colored",
					});
				});
		} else {
			Post(Url.changePassword, updatedData)
				.then((resp) => {
					toast("Password updated");
					User.setBiodata(resp);
					setTimeout(() => {
						window.location.reload();
					}, 1500);
				})
				.catch((err) => {
					const message =
						err?.response?.data?.["Null Pointer"] ||
						err?.response?.data?.message ||
						"Update failed.";

					toast.error(message, {
						theme: "colored",
					});
				});
		}
	};

	return (
		<div className={css.Settings}>
			<div className={css.Head}>
				<div>
					<ImgThumb size={120}>{userImg}</ImgThumb>
				</div>
				<div>
					<h2>User Profile</h2>
					<div>
						You can upload images up to 256x256. Your avatar shows up in your
						public profile and your team notifications.
					</div>
					<div className={css.Btn}>
						<Button className="Btn-Mid Active">Upload</Button>
					</div>
				</div>
			</div>

			<div>
				<h2 className={css.Title}>Account Details</h2>
				<div ref={profileFormRef}>
					<Form
						onSubmit={(children) => handleSubmit(children, "update-profile")}
					>
						{AccOptions}
					</Form>
				</div>
			</div>

			<div>
				<h2 className={css.Title}>Account Security</h2>
				<div ref={passwordFormRef}>
					<Form
						onSubmit={(children) => handleSubmit(children, "change-password")}
					>
						{SecureOptions}
					</Form>
				</div>
			</div>
		</div>
	);
};

export default Settings;
